import { jsx as _jsx } from "react/jsx-runtime";
import Button from "@mui/material/Button";
import { useCompany } from "../../../Shared/components/CompanyProvider/CompanyProvider";
import { BillingInfoText } from "../BillingInformation-types";
import { ResponsiveTable } from "../../../Shared/components/ResponsiveTable";
import { buildGiftCardTable } from "./";
const GiftCardTable = ({ currentGiftCards, oldGiftCards, setSelectedGiftCard, setIsOldGiftCardsModalOpen, setIsGiftCardMoreInfoModalOpen, }) => {
    const { culture } = useCompany();
    if (!((oldGiftCards && oldGiftCards.length > 0) || (currentGiftCards && currentGiftCards.length > 0))) {
        return null;
    }
    const { columns, rows } = buildGiftCardTable({
        giftCards: currentGiftCards || [],
        culture: culture,
        onMoreInfo: (giftCard) => {
            setIsGiftCardMoreInfoModalOpen(true);
            setSelectedGiftCard(giftCard);
        },
        // Only show basic columns for current gift cards
        excludeColumns: ["sender", "createdOn"],
    });
    return (_jsx(ResponsiveTable, { collapsible: true, defaultExpanded: true, caption: BillingInfoText.GIFT_CARDS, captionAction: oldGiftCards && oldGiftCards.length > 0 ? (_jsx(Button, Object.assign({ variant: "outlined", onClick: () => setIsOldGiftCardsModalOpen(true) }, { children: BillingInfoText.SEE_OLD_GIFT_CARDS }))) : null, columns: columns, rows: rows, noDataMessage: BillingInfoText.NO_GIFT_CARDS_AVAILABLE }));
};
export default GiftCardTable;
